import axios from "axios";
import { useEffect, useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { Helmet } from "react-helmet";
import Preloader from "../components/Preloader";

export default function Portfolio() {

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("https://apnaqwebx-mern.onrender.com/api/portfolio")
      .then(res => {
        setProjects(res.data);
        setLoading(false);
      })
      .catch(err => console.log(err));
  }, []);

  return (

    <>
      <Helmet>
        <title>Our Portfolio – Modern Websites Built by ApnaWebX</title>
        <meta name="description" content="View our professional website portfolio showcasing business websites, eCommerce stores, branding projects, UI/UX design, and digital solutions delivered for clients." />
         <meta name="keywords" content="website portfolio, web development work, business websites gallery, apnawebx portfolio, modern website designs" />

        <link rel="canonical" href="https://apnawebx.com/" />

        {/* Open Graph */}
        <meta property="og:title" content="Our Portfolio – Websites by ApnaWebX" />
        <meta property="og:description" content="Explore stunning, high-performance websites built for various industries." />
        <meta property="og:image" content="https://apnawebx.com/images/portfolio-og.jpg" />
        <meta property="og:url" content="https://apnawebx.com/portfolio" />



        <script type="application/ld+json">
          {`  {
          "@context": "https://schema.org",
        "@type": "Organization",
        "name": "ApnaWebX",
        "url": "https://apnawebx.com",
        "logo": "https://apnawebx.com/images/logo/apnawebxlogo.png",
        "description": "We provide website development, branding, SEO, WhatsApp automation & digital services.",
        "address": {
          "@type": "PostalAddress",
        "addressLocality": "Ahmedabad",
        "addressRegion": "Gujarat",
        "addressCountry": "IN"
  },
        "sameAs": [
        "https://www.instagram.com/apnawebx",
        "https://www.facebook.com/apnawebx"
        ]
}
        `}
        </script>

      </Helmet>

      <div>

        {/* BREADCRUMB */}
        <Breadcrumb
          title="Our Portfolio"
          paths={[{ label: "Portfolio", link: null }]}
        />

        <div className="py-14 bg-[#faf7f2]">

          {/* HEADER */}
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#855109]">
              Our Portfolio
            </h1>
            <p className="text-gray-600 mt-3 text-lg">
             We have created beautiful, clean, and modern websites for companies across various industries.
Each project is designed with attention to detail, performance, and user experience.
            </p>
          </div>


            <div className="max-w-7xl mx-auto px-6 mt-14">

  {loading ? (
    <Preloader />   
  ) : (
    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10">
     {projects.map((project) => (
              <a
                key={project._id}
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <img
                  src={project.image}
                  alt="ApnaWebX"
                  loading="lazy"
                  className="object-cover w-full h-64 group-hover:scale-110 transition-all duration-500"
                />

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center justify-center">
                  <button className="px-5 py-2.5 bg-white text-[#855109] font-bold rounded-xl shadow-md group-hover:scale-105 transition">
                    View Website
                  </button>
                </div>

                {/* Title */}
                <div className="absolute bottom-0 w-full bg-[#f8ede3]/90 text-center text-[#855109] py-2 px-4">
                  <span className="text-lg font-bold">{project.title}</span>
                </div>
              </a>
            ))}
    </div>
  )}

</div>

          


        </div>
      </div>
    </>);
}
